// eslint-disable-next-line import/prefer-default-export
export const USER_PREFERENCES = {
  wizard: true,
  translationWarning: true,
  loadOnPageSelect: true,
};
